import { render, staticRenderFns } from "./CardTypeSelector.vue?vue&type=template&id=4a31c70e&scoped=true&"
import script from "./CardTypeSelector.vue?vue&type=script&lang=js&"
export * from "./CardTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./CardTypeSelector.vue?vue&type=style&index=0&id=4a31c70e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a31c70e",
  null
  
)

export default component.exports